import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { SafeInnerHtmlSetter } from 'components/shared/util/SafeInnerHtmlSetter';
import '../styles/assistant-summary.less';
export default class AssistantSummaryItem extends React.Component {
    constructor(props) {
        super(props);
        this.overflowRef = React.createRef();
        this.toggleExpand = this.toggleExpand.bind(this);
        this.checkForOverflow = this.checkForOverflow.bind(this);
        this.removeTrailingNewlines = this.removeTrailingNewlines.bind(this);
        this.removeBlockTagsFromFirstLine =
            this.removeBlockTagsFromFirstLine.bind(this);
        this.prepareMessage = this.prepareMessage.bind(this);
        this.renderMessage = this.renderMessage.bind(this);
        this.state = {
            hasOverflow: false,
            isExpanded: false,
        };
    }
    componentDidMount() {
        window.addEventListener('resize', this.checkForOverflow);
        this.checkForOverflow();
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.checkForOverflow);
    }
    checkForOverflow() {
        const { current } = this.overflowRef;
        if (current) {
            this.setState({
                hasOverflow: current.offsetHeight > 24, // Magic number 🔫
            });
        }
    }
    toggleExpand() {
        const { isExpanded } = this.state;
        this.setState({
            isExpanded: !isExpanded,
        });
    }
    removeTrailingNewlines(markup) {
        return markup ? markup.replace(/(<br\/?>)+$/, '') : '';
    }
    removeBlockTagsFromFirstLine(markup) {
        const tempNode = document.createElement('div');
        // TODO: [TEAMS-12076] Investigate improper use of innerHTML
        tempNode.innerHTML = markup;
        const firstElement = tempNode.firstElementChild;
        if (firstElement && ['DIV', 'P'].includes(firstElement.tagName)) {
            const spanReplacement = document.createElement('span');
            // TODO: [TEAMS-12076] Investigate improper use of innerHTML
            spanReplacement.innerHTML = firstElement.innerHTML;
            tempNode.insertBefore(spanReplacement, firstElement);
            tempNode.removeChild(firstElement);
        }
        return tempNode.innerHTML;
    }
    prepareMessage(markup) {
        const { isExpanded } = this.state;
        if (!markup)
            return '';
        const markdownWithoutLeadingBlock = this.removeBlockTagsFromFirstLine(markup);
        if (!isExpanded) {
            return sanitizeHtml(markdownWithoutLeadingBlock, {
                allowedTags: [],
            });
        }
        return this.removeTrailingNewlines(markdownWithoutLeadingBlock);
    }
    renderMessage() {
        const { category, message, action, value } = this.props;
        const markup = this.prepareMessage(message);
        return (_jsxs(React.Fragment, { children: [_jsxs("span", Object.assign({ className: "assistant-summary-item__text" }, { children: [category, " shown"] })), "\u00A0\"", _jsx(SafeInnerHtmlSetter, { element: "span", content: markup, noSanitize: true, className: "assistant-summary-item__text assistant-summary-item__text--crop" }), "\"", !!action && (_jsxs("span", Object.assign({ className: "assistant-summary-item__text" }, { children: ["\u00A0and ", action] }))), !!value && (_jsxs("span", Object.assign({ className: "assistant-summary-item__text" }, { children: ["\u00A0\"", _jsx("strong", { children: value }), "\""] })))] }));
    }
    render() {
        const { hasOverflow, isExpanded } = this.state;
        const rootClass = classnames('assistant-summary-item', {
            'assistant-summary-item--expandable': hasOverflow,
            'assistant-summary-item--expanded': isExpanded,
        });
        return (_jsxs("li", Object.assign({ className: rootClass }, { children: [_jsx("div", Object.assign({ className: "assistant-summary-item__bullet" }, { children: hasOverflow && (_jsx("button", Object.assign({ onClick: this.toggleExpand, className: "assistant-summary-item__toggle" }, { children: _jsx(DixaIcon, { icon: "angle-right" }) }))) })), this.renderMessage(), _jsx("div", Object.assign({ ref: this.overflowRef, className: "assistant-summary-item__overflow-container" }, { children: this.renderMessage() }))] })));
    }
}
